import type { InitialConfigType } from '@lexical/react/LexicalComposer';
import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import LexicalErrorBoundary from '@lexical/react/LexicalErrorBoundary';
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin';
import type { SerializedEditorState } from 'lexical';
import { ParagraphNode, TextNode } from 'lexical';
import { BeautifulMentionNode } from 'lexical-beautiful-mentions';
import { useMemo } from 'react';
import { beautifulMentionsTheme } from './components';

export function Display({ content }: { content: SerializedEditorState }) {
  const editorConfig = useMemo((): InitialConfigType => {
    return {
      namespace: 'CommentDisplay',
      editable: false,
      editorState: content ? JSON.stringify(content) : undefined,
      onError: (error: Error) => console.error(error),
      nodes: [ParagraphNode, TextNode, BeautifulMentionNode],
      theme: {
        beautifulMentions: beautifulMentionsTheme,
      },
    };
  }, [content]);

  return (
    <div>
      <LexicalComposer initialConfig={editorConfig}>
        <div className='relative mx-auto max-w-[600px] rounded-medium rounded-t-[10px] text-left font-normal leading-[20px] text-black'>
          <div className='relative rounded-medium'>
            <RichTextPlugin
              contentEditable={
                <ContentEditable className='contenteditable relative resize-none border-none text-[15px] text-small leading-normal caret-[#444] outline-none' />
              }
              ErrorBoundary={LexicalErrorBoundary}
            />
          </div>
        </div>
      </LexicalComposer>
    </div>
  );
}
